import { PageHeader } from "@/components/DashboardLayout";
import BrokerDealsTable from "@/components/BrokerDealsTable";

export default function Profiles() {
    return (
        <>
            <PageHeader
                eyebrow="Catalogue"
                title="Product profiles"
                description="The real, member-facing products Perx has linked to your vendor. View only — pricing and listing details are managed by Perx."
                testid="broker-profiles-header"
            />

            <div className="px-6 lg:px-12 py-8">
                <BrokerDealsTable />
            </div>
        </>
    );
}
